export class ProductVariant {
  constructor(
    dimensions,
    dimensionKeys,
    variants,
  ) {
    /** @type {[Dimension]}*/
    this.dimensions = dimensions;
    this.dimensionKeys = dimensionKeys;
    /** @type {[Variant]}*/
    this.variants = variants;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new ProductVariant(
        Dimension.fromApiArray(input.data),
        input.reordered_dimensions,
        Variant.fromApiArray(input.variants),
      )
    }

    return new ProductVariant();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => ProductVariant.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [ProductVariant.fromApiObject(input)];
    }

    return [];
  }
}

export class Dimension {
  constructor(
    dimensionCode,
    label,
    /** @type {[DimensionValue]}*/
    values,
    displayType,
  ) {
    this.dimensionCode = dimensionCode;
    this.label = label;
    this.values = values;
    this.displayType = displayType;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Dimension(
        input.dimension_code,
        input.label,
        DimensionValue.fromApiArray(input.values),
        input.display_type,
      )
    }

    return new Dimension();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Dimension.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Dimension.fromApiObject(input)];
    }

    return [];
  }

  static TYPE = {
    DROPDOWN: "dropdown"
  }
}

export class DimensionValue {
  constructor(
    items,
    label,
  ) {
    /** @type {[DimensionValueItem]}*/
    this.items = items;
    this.label = label;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new DimensionValue(
        DimensionValueItem.fromApiArray(input.items),
        input.label,
      )
    }

    return new DimensionValue();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => DimensionValue.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [DimensionValue.fromApiObject(input)];
    }

    return [];
  }
}

export class DimensionValueItem {
  constructor(
    image,
    label,
    value
  ) {
    this.image = image;
    this.label = label;
    this.value = value;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new DimensionValueItem(
        input.image,
        input.label,
        input.value,
      )
    }

    return new DimensionValueItem();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => DimensionValueItem.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [DimensionValueItem.fromApiObject(input)];
    }

    return [];
  }
}

export class Variant {
  constructor(
    currency,
    productId,
    siteId,
    sku,
    unitPrice,
    dimensions,
    url,
    isAvailable,
  ) {
    this.currency = currency;
    this.productId = productId;
    this.siteId = siteId;
    this.sku = sku;
    this.unitPrice = unitPrice;
    this.dimensions = dimensions;
    this.url = url;
    this.isAvailable = isAvailable;

  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Variant(
        input.cur,
        input.product_id,
        input.site_id,
        input.sku,
        input.unit_price,
        input.dimensions,
        input.url,
        input.is_available,
      )
    }

    return new Variant();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Variant.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Variant.fromApiObject(input)];
    }

    return [];
  }
}